import { render, staticRenderFns } from "./ChallengesComponent.vue?vue&type=template&id=406af086&lang=pug&"
import script from "./ChallengesComponent.vue?vue&type=script&lang=js&"
export * from "./ChallengesComponent.vue?vue&type=script&lang=js&"
import style0 from "./ChallengesComponent.vue?vue&type=style&index=0&id=406af086&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports